import { isValidElement } from 'react';
import { makeStyles } from 'tss-react/mui';
import {
  Card, Typography, CardContent, Grid,
} from '@mui/material';
import { useIsMobile } from '@client/hooks/dom.hooks';

const useStyles = makeStyles()((theme) => ({
  root: {
    '&:not(:last-child)': {
      paddingBottom: theme.spacing(8),
      marginBottom: theme.spacing(3),
    },

    '&:last-child': {
      marginBottom: 0,
    },
  },
  border: {
    '&:not(:last-child)': {
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: theme.palette.divider,
    },
  },
  title: {
    marginBottom: theme.spacing(3),

    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
    },
  },
  table: {
    padding: '0px !important',
  },
  noPaddingTitle: {
    marginLeft: '0px !important',
  },
  padding_none: {
    padding: 0,

    '&:last-child': {
      paddingBottom: 0,
    },
  },
  padding_normal: {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),

    '&:last-child': {
      paddingBottom: theme.spacing(2),
    },
  },
  padding_wide: {
    padding: theme.spacing(3),

    '&:last-child': {
      paddingBottom: theme.spacing(3),
    },

    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(7),

      '&:last-child': {
        paddingBottom: theme.spacing(7),
      },
    },
  },
}));

export const Section = ({
  children,
  title,
  titleVariant = 'h5',
  padding,
  cardComponent: Component = null,
  cardHeader: CardHeader = null,
  secondaryAction = null,
  className = '',
  variant = 'normal',
  CardProps = {},
  showBorder = true,
}) => {
  const { classes, cx } = useStyles();
  const isMobile = useIsMobile();

  let sectionPadding = padding;

  if (!sectionPadding) {
    sectionPadding = isMobile ? 'normal' : 'none';
  }

  return (
    <div className={cx(classes.root, showBorder && classes.border, className)}>
      {title && (
        <div className={cx(classes.title, sectionPadding === 'none' && classes.noPaddingTitle)}>
          <Grid
            container
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Typography variant={titleVariant}>{title}</Typography>
            </Grid>

            {secondaryAction && (
              <Grid item>
                {secondaryAction}
              </Grid>
            )}
          </Grid>
        </div>
      )}

      {Component ? (
        <>
          {isValidElement(Component) ? (
            <>{Component}</>
          ) : (
            <Component />
          )}
        </>
      ) : (
        <Card
          square={isMobile}
          {...CardProps}
        >
          {CardHeader && (
            <>
              {isValidElement(CardHeader) ? (
                <>{CardHeader}</>
              ) : (
                <CardHeader />
              )}
            </>
          )}

          {Boolean(children) && (
            <CardContent className={cx(classes[`padding_${sectionPadding}`], variant === 'table' && classes.table)}>
              {children}
            </CardContent>
          )}
        </Card>
      )}
    </div>
  );
};
